import { t } from "@lingui/macro";
import { ArrowSquareOutIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";

import { useSubscription } from "@/client/hooks/use-subscription";

import { BaseCard } from "./base-card";

const BotMessageIcon = ({ className, size = 56 }: { className?: string; size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <path d="M12 6V2H8" />
    <path d="M15 11v2" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="M20 16a2 2 0 0 1-2 2H8.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 4 20.286V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z" />
    <path d="M9 11v2" />
  </svg>
);

export const HiAgentImportCard = () => {
  const { subscription } = useSubscription();
  const isPlusUser = subscription?.productType === "plus";

  const handleClick = () => {
    /* eslint-disable lingui/no-unlocalized-strings */
    const query = encodeURIComponent("import mon cv a Hi Resume");
    const targetUrl = isPlusUser
      ? `https://student.hi-interns.com/dashboard/?cv=convert`
      : `https://agent.hi-interns.com?query=${query}`;
    window.open(targetUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <BaseCard
      className={cn(
        "relative overflow-hidden border-2",
        "border-[#23e7a1]/30",
        "bg-gradient-to-br from-[#23e7a1]/5 via-background to-background",
        "transition-all duration-300 hover:border-[#23e7a1]/60",
        "hover:shadow-lg hover:shadow-[#23e7a1]/10",
      )}
      onClick={handleClick}
    >
      <div className="flex flex-col items-center justify-center gap-2">
        <BotMessageIcon size={56} className="text-black dark:text-[#23e7a1]" />
        <ArrowSquareOutIcon
          size={18}
          weight="bold"
          className="absolute right-4 top-4 text-black/50 dark:text-[#23e7a1]/50"
        />
      </div>

      <div
        className={cn(
          "absolute inset-x-0 bottom-0 z-10 flex flex-col justify-end space-y-1 p-4 pt-12",
          "bg-gradient-to-t from-background via-background/95 to-transparent",
        )}
      >
        <h4 className="font-bold">{t`Already have a resume?`}</h4>

        <p className="text-sm font-medium opacity-90">{t`Import it`}</p>

        <p className="text-xs opacity-60">{t`PDF, Word, etc.`}</p>
      </div>
    </BaseCard>
  );
};
